<template>
  <b-row>
     <b-col sm="12">
      <b-table hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" 
          ref="table"
          :items="myProvider" 
          :fields="fields" 
          :current-page="currentPage" 
          :per-page="perPage"
          @filtered="onFiltered" 
          :filter="filter"
          sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :busy.sync="isBusy"
          :no-provider-paging="noProviderPaging"
          :no-provider-filtering="noProviderFiltering"
          :no-provider-sorting="noProviderSorting">

        <template slot="request_date" slot-scope="data">
          {{data.item.request_date | formatDate('DD/MM/YYYY HH:mm:ss')}} 
        </template>
        <template slot="last_update" slot-scope="data">
          {{data.item.last_update | formatDate('DD/MM/YYYY HH:mm:ss')}} 
        </template>
        <template slot="status" slot-scope="data">
          <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>          
        </template>
        <template slot="action" slot-scope="data" style="width:20px">
                <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                  <template slot="button-content">
                    <i class="icon-settings"></i>
                  </template> 

                  <!-- <b-dropdown-item @click="viewEventHandler(data.item.id, data.item.request_type_id)">Edit Form</b-dropdown-item>
                  <b-dropdown-item v-if="data.item.request_type_id !== 1" @click="mofaEventHandler(data.item)">MoFA</b-dropdown-item>
                  <b-dropdown-item @click="itemEventHandler(data.item)" v-b-modal.sendEmailModal v-b-modal.modal-center>Notify Requester</b-dropdown-item> -->
                  <b-dropdown-item @click="itemEventHandler(data.item)" v-b-modal.changeStatusModal v-b-modal.modal-center>Change Status</b-dropdown-item>
                  <!-- <b-dropdown-item @click="downloadEventHandler(data.item.id, data.item.request_type_id)">Download</b-dropdown-item> -->
                </b-dropdown> 
        </template>
      </b-table>
      <nav>
      <!-- <b-pagination size="sm" :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"/> -->
      <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" prev-text="Prev" next-text="Next"/>
    </nav>  
    </b-col>

    <!--// MODAL Change Status -->   
     <b-modal centered ref="changeStatusModal" title="Notification Status" class="modal-primary" id="changeStatusModal" @ok="submitStatusEventHandler">
      <b-row>
        <b-col sm="12">
          <b-form>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label for="city">Agency</label>
                    <b-form-input type="text" id="city" v-model="selectedItem.agency_desc" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="postal-code">Requested Date</label>
                    <b-form-input type="text" id="requestedDate" :value="selectedItem.request_date | formatDate('DD/MM/YYYY')" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group>
                    <label for="city">Purpose of Mission</label>
                    <b-form-input type="text" id="purposeMission" :value="selectedItem.purpose_desc" disabled></b-form-input>
              </b-form-group>
              <b-row>
                <b-col sm="7">
                  <b-form-group>
                    <label for="ehoc-ref">Generate NV# for</label> 
                    <b-input-group>
                      <b-form-select :value="selectedNV" :options="nvOptions" text-field="text" value-field="value" @change="selectNVChangeEventHandler">
                      <template slot="first">
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>  
                      </b-form-select>
                      <b-input-group-append>
                         <b-button variant="secondary" @click="nextNVEventHandler" title="Generate NV#" ><i class="fa fa-magic"></i></b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>   
                <b-col sm="5"> 
                  <b-form-group>
                    <label for="country">NV#</label>
                    <b-input-group>
                      <b-form-input type="text" v-model="nvNumber" id="nvNumber" disabled></b-form-input>                      
                    </b-input-group>  
                  </b-form-group>
                </b-col>                
              </b-row>
              <b-row>
                <b-col sm="6"> 
                  <b-form-group>
                    <label for="country">Status</label>                      
                    <b-form-select :value="selectedStatusId" @change="statusChangeEventHandler">
                        <option :value="null" disabled>-- Please select an option --</option>
                        <option v-for="item in statusList" :value="item.id" v-if="item.id !== 2 && item.id !== 13">{{item.name}}</option> 
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="ehoc-ref">EHOC Ref#</label>
                    <b-form-input type="text" v-model="ehoc_ref" placeholder=""></b-form-input>
                  </b-form-group>
                </b-col>                   
              </b-row>
              <b-form-group>
                  <label for="country">Notes</label>
                  <b-form-textarea id="notes" ref="notes"
                    v-model="notes"
                     placeholder=""
                     :rows="3"
                     :max-rows="6">
                  </b-form-textarea>
              </b-form-group>              
          </b-form>        
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Change Status -->  

    <!--// MODAL Send Email Notification-->   
     <b-modal centered ref="sendEmailModal" title="Notify Requester" class="modal-primary" id="sendEmailModal" @ok="sendEmailEventHandler" ok-title="Send">
      <b-row>
        <b-col sm="12">
          <b-form>
              <b-row>
                <b-col sm="8">
                  <b-form-group>
                    <label>To</label>
                    <b-form-input type="text" id="city" v-model="selectedItem.requested_by_email" disabled></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="4">
                  <b-form-group>
                    <label for="postal-code">Date</label>
                    <b-form-input type="text" id="currentDate" :value="this.currentDate | formatDate('DD/MM/YYYY')" disabled></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group>
                    <label for="city">Subject</label>
                    <b-form-input type="text" id="emailSubject" v-model="emailSubject"></b-form-input>
              </b-form-group>             
              <b-form-group>
                  <label>Message</label>
                  <b-form-textarea id="emailMessage"
                    v-model="emailMessage"
                     placeholder=""
                     :rows="5"
                     :max-rows="10">
                  </b-form-textarea>
              </b-form-group>
              <!-- <b-form-group>
                  <label>Attachments</label>
                  <file-upload
                          ref='fileUpload'
                          title='Please enter description of the file into the description field and click "Browse" to select file from your local computer.  When ready, click "Start Upload" to start uploading the file.'
                          accept=".png, .jpg, .jpeg"
                          @event-handler="fileUploadEventHandler($event)">            
                    </file-upload>
              </b-form-group>               -->
          </b-form>        
        </b-col>
      </b-row>
    </b-modal>  
    <!--// MODAL Change Status -->  

  </b-row> 

</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'
import NotificationService from '@/api/NotificationService'
import LandMovementService from '@/api/LandMovementService'
import TempVenueService from '@/api/TempVenueService'
import SeaService from '@/api/SeaService'
import AirService from '@/api/AirService'
import NSLService from '@/api/NSLService'
import CommonService from '@/api/CommonService'
import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'
import Api from '@/api/Api'

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export default {

  components: {
    FileUpload
  },
  
  data: () => {
    return {      
      nvOptions: [
        { value: 1, text: 'UN' },
        { value: 2, text: 'I/NGOs'}
      ],
      fields: [
        // {label: 'Notification #', key: 'id', sortable: true},
        {label: 'Date Submitted', key: 'date_submitted', sortable: true},
        {label: 'Site Type', key: 'site_type', sortable: true},
        {label: 'Type', key: 'type', sortable: true},        
        {label: 'Organization Name', key: 'organization_name', sortable: true},
        {label: 'DMS', key: 'dms', sortable: true},        
        {label: 'Latitude', key: 'latitude'},
        {label: 'Longitude', key: 'longitude'},
        {label: 'District', key: 'district', sortable: true},
        {label: 'Governorate', key: 'governorate', sortable: true},
        {label: 'Location Name', key: 'locaction_name', sortable: true},
        {label: 'Arabic Location Name', key: 'ar_location_name', sortable: true},
        {label: 'Action', key: 'action'}
      ],
      nvNumber: 0,
      selectedNV: null,
      currentDate: new Date(),
      emailTo: null,
      emailSubject: null,
      emailMessage: null,
      // currentPage: 1,
      // perPage: 10,
      // totalRows: 0,
      statusModal: false,
      notes: null,
      ehoc_ref: null,
      selectedItem: {agency_desc: '', request_date: '', purpose_desc: '', status_id: 0, ehoc_ref: '', notes: ''},
      selectedStatusId: 0,

      currentPage: 1,
      perPage: 10,
      message: null,
      pageOptions: [ 5, 10, 15 ],
      sortBy: 'id',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      isBusy: false,
      noProviderPaging: false,
      noProviderFiltering: false,
      noProviderSorting: false
    }
  },
  computed: {
    ...mapGetters({
        items : types.GET_NOTIFICATION_LIST,
        agencyId: types.GET_USER_AGENCY_ID,
        statusList: types.GET_STATUSES,
        requestTypeId: types.GET_REQUEST_TYPE_ID,
        totalRows : types.GET_TOTAL_ROWS
    })
  },

  created() {
       this.$store.dispatch(types.ACTION_TOTAL_ROWS)
  },

  methods: {

    myProvider (ctx) {

      return(items || [])
      
      ctx.searchField = this.sortBy
      let offset = ctx.perPage * (ctx.currentPage-1)
      let agencyId = this.$store.state.agencyId

      let promise = Api().get('/notifications?keyword='+ (ctx.filter ? ctx.filter : '') +
                              '&field='+ ctx.searchField +
                              '&sortby='+  (ctx.sortBy ? ctx.sortBy : 'id') +
                              '&sortdesc='+ ctx.sortDesc +
                              '&offset='+ offset +
                              '&limit='+ ctx.perPage)

      // Must return a promise that resolves to an array of items
      return promise.then((response) => {
        // Pluck the array of items off our axios response
        let items = response.data
        // Must return an array of items or an empty array if an error occurred
        return(items || [])
      })
      .catch( error => {
            if (error.response) {
                  if (error.response.status = 401) {
                      toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                      this.$router.replace('/login')
                  } 
                  else  {
                      toast.error( error.response.message, "Error")                      
                  }
                } else if (error.request) {
                  console.log(error.request)                      
                  toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);                      
                }
        })
    },

    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    sendEmailEventHandler() {
        const $this = this
        let emailTo = this.selectedItem.requested_by_email

        let payload = {
            to: emailTo,
            subject: this.emailSubject,
            message: this.emailMessage
        }

        NotificationService.notify(payload).then( (resp) => {
          toast.success( "The notification email has been sent to "+ emailTo)
        })
    },


    getBadge (status) {
      return status === 'Received' ? 'secondary'
             : status === 'Approved' ? 'success'
             : status === 'Pending' ? 'warning'
             : status === 'Returned' ? 'info'
             : status === 'Cancelled' ? 'danger' : 'primary'
    },
    getAction (action) {
      return action
    },
    getRowCount (items) {
      return items.length
    },
    downloadEventHandler(notificationId, requestTypeId) {
      
      NotificationService.download(notificationId, requestTypeId).then( (resp) => {
          
      })
    },
    
    itemEventHandler(item) {
        console.log("**** item ****")
        console.log(item)
        
        this.selectedItem = item
        this.selectedStatusId = item.status_id
        this.notes = item.notes
        this.ehoc_ref = item.ehoc_ref
        this.selectedNV = item.nv_for
        this.nvNumber = item.nv_number

        this.emailSubject = null
        this.emailMessage = null

    },
    mofaEventHandler(item) {
       this.$store.commit(types.MUTATE_VIEW_MOFA, true)
       this.$store.commit(types.MUTATE_NOTIFICATION_ID, item.id)
       this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, item.request_type_id)

       const routeName = utils.findMofaNameById( item.request_type_id )

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:item.id})
        }.bind(this), 600)
       
       // load MOFA form       
       this.$router.replace('/forms/'+ routeName +"-mofa")
    },
    viewEventHandler(notificationId, requestTypeId) {

       this.loadNotification(notificationId) 

       if (requestTypeId === constants.FORM_LAND_MOVEMENT) {
            this.loadLandMovement(notificationId) 
       }
       else if (requestTypeId === constants.FORM_TEMP_VENUE) {
            this.loadTempVenue(notificationId) 
       }
       else if (requestTypeId === constants.FORM_SEA) {
            this.loadSea(notificationId) 
       }
       else if (requestTypeId === constants.FORM_AIR) {
            this.loadAir(notificationId) 
       }
       else if (requestTypeId === constants.FORM_NO_STRIKE_LIST) {
            this.loadNSL(notificationId) 
       }
       else if (requestTypeId === constants.FORM_ADMIN_LETTERS) {
            this.loadAdminLetters(notificationId) 
       }
    },
    loadNotification(notificationId) {
       // get notification
       NotificationService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_MODE, constants.MODE_EDIT)
          this.$store.commit(types.MUTATE_NOTIFICATION_ID, resp.id)
          this.$store.commit(types.MUTATE_USER_AGENCY_ID, resp.agency_id)
          this.$store.commit(types.MUTATE_PURPOSE_ID, resp.purpose_id)
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, resp.purpose_others)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_MAP, {roadmap: resp.route_map_terrain, satellite: resp.route_map_satellite})          
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id)
          this.$store.commit(types.MUTATE_EHOC_REF, resp.ehoc_ref)
          this.$store.commit(types.MUTATE_CENTCOM_REF, resp.centcom_ref)
          this.$store.commit(types.MUTATE_NV_FOR, resp.nv_for)
          this.$store.commit(types.MUTATE_NV_NUMBER, resp.nv_number)
          this.$store.commit(types.MUTATE_REQUEST_TYPE_ID, resp.request_type_id) 
          this.$store.commit(types.MUTATE_REQUESTED_BY, resp.requested_by)
          this.$store.commit(types.MUTATE_LAST_UPDATED_BY, resp.last_updated_by) 
          this.$store.commit(types.MUTATE_NOTES, resp.notes)
          this.$store.commit(types.MUTATE_STATUS_ID, resp.status_id)
          this.$store.commit(types.MUTATE_START_DATE, resp.start_date)
          this.$store.commit(types.MUTATE_REQUESTED_DATE, resp.request_date) 
       }) 
    },
    loadLandMovement(notificationId) {
      
       // get waypoints
       LandMovementService.getWaypoints(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_WAYPOINTS, resp)          
       })

       // get convoys 
       LandMovementService.getConvoys(notificationId).then( (resp) => {    
          this.$store.commit(types.MUTATE_CONVOYS, resp)
       })

       // get participants 
       LandMovementService.getParticipants(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_PARTICIPANTS, resp)
       })

       // get vehicles 
       LandMovementService.getVehicles(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_VEHICLES, resp)
       })

       // get trucks 
       LandMovementService.getTrucks(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_TRUCKS, resp)
       })

       // get photos 
       LandMovementService.getPhotos(notificationId).then( (resp) => {        
          this.$store.commit(types.MUTATE_PHOTOS, resp)
       })

       // load land movement form
       this.$router.replace('/forms/land-movement')

    },
    loadTempVenue(notificationId) {

       TempVenueService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_VENUES, resp)
       })

       // get upload documents 
       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

        // temp venue
       this.$router.replace('/forms/temp-venue')
    },
    loadSea(notificationId) {

       SeaService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_SEA, resp)
       })

       // sea
       this.$router.replace('/forms/sea-movement')
    },
    loadAir(notificationId) {

        setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_AIR, notificationId)
        }.bind(this), 600)

        // get upload documents 
       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // air
       this.$router.replace('/forms/air-movement')
    },
    loadNSL(notificationId) {

       NSLService.fetchByNotificationId(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_NSL, resp)
       })

       // air
       this.$router.replace('/forms/no-strike-list')
    },
    loadAdminLetters(notificationId) {

       CommonService.fetchAttachment(notificationId).then( (resp) => {
          this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
       })

       // admin letters
       this.$router.replace('/forms/admin-letters')
    },
    submitStatusEventHandler(e) {
        // e.preventDefault()
        const payload = {
            id : this.selectedItem.id,
            status_id : this.selectedStatusId,
            notes : this.notes,
            ehoc_ref: this.ehoc_ref,
            nv_for: this.selectedNV,
            nv_number: this.nvNumber,
            last_updated_by: this.$store.state.userId
        }
        this.$store.dispatch(types.ACTION_UPDATE_NOTIFICATION_STATUS, payload)        
        this.$refs.changeStatusModal.hide()
        
        let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedStatusId});
        let agencyObj = this.$_.find(this.$store.state.agencyList, {id: this.agencyId});
        let requestTypeObj = this.$_.find(this.$store.state.requestTypeList, {id: this.selectedItem.request_type_id});
        let emailTo = this.selectedItem.requested_by_desc
        let messageBody = "Notification Details:\n\n"+
                          "Notification #: "+ this.selectedItem.id +"\n" +
                          "NV#: "+ this.selectedItem.nv_number +"\n"+                          
                          "Agency: "+ agencyObj.name +"\n"+
                          "Request type: "+ requestTypeObj.description+"\n"
                          "Status: "+ statusObj.name

        let notify = {
            to: emailTo,
            subject: "Notification # "+ this.selectedItem.id + " status changed",
            message: messageBody
        }

        NotificationService.notify(notify).then( (resp) => {
          toast.success( "The notification email has been sent to "+ emailTo)
        })

        setTimeout(function () {
            // this.$store.dispatch(types.ACTION_ADMIN_NOTIFICATION_LIST)
            this.$refs.table.refresh();
            this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, constants.AGENCY_ADMIN)
        }.bind(this), 300)
    },

    statusChangeEventHandler(e) {
      this.selectedStatusId = e
      let statusObj = this.$_.find(this.$store.state.statusList, {id: this.selectedStatusId});

      this.notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss') + '\n' + statusObj.name
    },

    selectNVChangeEventHandler(e) {
      this.selectedNV = e
    },

    nextNVEventHandler() {
       const $this = this

       if ( eval(this.selectedNV) === null ) {
           toast.error("Please select an option to generate NV# ", "Error")
           return false
       }

       NotificationService.generateNextNVNumber(this.selectedNV).then( (resp) => {
            if (parseInt($this.selectedNV) === 1)
                $this.nvNumber = resp.last_nv_un
            else if (parseInt($this.selectedNV) === 2)  
                $this.nvNumber = resp.last_nv_ingo
       })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/list/NoStrikeList.vue